import { FrameworkMessenger } from "./FrameworkMessenger";
import WrapperHandler from "./WrapperHandler";

const fwListener = window.IntouchGames.GameFramework.ModuleMessenger.registerNewMessageListener;
const FW = window.IntouchGames.GameFramework;

export default class FrameworkDispatcher
{
    private currentStage: number = 0;
    private currentRoundEndState: number = 0;
    private currentBetValue: number = 0;

    private roundStarted: boolean = false;
    private paytableOpened: boolean = false;
    private inFreeGame: boolean = false;

    private wrapperHandler: WrapperHandler = new WrapperHandler();

    public init()
    {
        this.wrapperHandler.addApiListeners()
        this.addListeners();
    }

    public initSwContext(): void {
        this.wrapperHandler.initDispatcher();
        this.wrapperHandler.addListeners();
        this.wrapperHandler.initContext();
    }

    public addListeners()
    {
        fwListener(this, FW.GameRequestMessage)
        fwListener(this, FW.ReelsResumeSetupMessage)
        fwListener(this, FW.ReelsSpinEndedModuleMessage)
        fwListener(this, FW.ReelsSpinStartedModuleMessage)
        fwListener(this, FW.InfoPanelStateModuleMessage)
        fwListener(this, FW.OpenExternalMenuMessage)
        fwListener(this, FW.BigWinAnimationStateMessage)
        fwListener(this, FW.JackpotWinAnimationFinishedMessage)
        fwListener(this, FW.GameResponseMessage)
        fwListener(this, FW.CommandsCompleteModuleMessage)

        try{ fwListener(this, FW.ExternalSetBetModuleMessage) } catch(e){ };
        try{ fwListener(this, FW.ExternalBetChangedModuleMessage) } catch(e){ };
        fwListener(this, FW.ExternalSetBetUnitsMessage)
        try{ fwListener(this, FW.ExternalResumeRequest) } catch(e){ };
        try{ fwListener(this, FW.ExternalResumeRequestMessage) } catch(e){ };
        fwListener(this, FW.ExternalGameRequestMessage)

        fwListener(this, FW.GameRequestMessage);
        fwListener(this, FW.ReelsResumeSetupMessage);
        fwListener(this, FW.ReelsSpinEndedModuleMessage);
        fwListener(this, FW.ReelsSpinStartedModuleMessage);
        fwListener(this, FW.InfoPanelStateModuleMessage);
        fwListener(this, FW.OpenExternalMenuMessage);
        fwListener(this, FW.BigWinAnimationStateMessage);
        fwListener(this, FW.JackpotWinAnimationFinishedMessage);
        fwListener(this, FW.GameResponseMessage);
        fwListener(this, FW.CommandsCompleteModuleMessage);
        fwListener(this, FW.PlayerWonModuleMessage);
        fwListener(this, FW.AutoSpinStateChangedMessage);

        fwListener(this, FW.MiniGameEnteringModuleMessage);
        fwListener(this, FW.MiniGameFinishedModuleMessage);
        fwListener(this, FW.CreditChangedModuleMessage);
        fwListener(this, FW.RespinsCompleteResponseMessage);
        try { fwListener(this, FW.FreeSpinsInProgressMessage) } catch (e) { };  // FW1
        try { fwListener(this, FW.FreeSpinsFinishedMessage) } catch (e) { };  // FW1
        try { fwListener(this, FW.FreeSpinDisplayStateChangedMessage) } catch (e) { };  // FW2

        try { fwListener(this, FW.ExternalGameTitleChanged) } catch (e) { };  // FW1

        try { fwListener(this, FW.ExternalShowMessageBoxMessage) } catch (e) { };  // FW2
        fwListener(this, FW.HideMessageBoxMessage);
    }

    public isActive() {
        return true;
    }

    public handleMessage(message: any) {
        switch (message.constructor.name) {
            case "GameResponseMessage":
                this.receiveGameResponse(message.response);
                break;

            case "ReelsResumeSetupMessage":
                this.wrapperHandler.init();
                break;

            case "ReelsSpinEndedModuleMessage":
                this.spinStoppedHandler();
                break;

            case "ReelsSpinStartedModuleMessage":
                this.spinStartedHandler();
                break;

            case "InfoPanelStateModuleMessage":
                this.payTableEventHandler(message.isOpen);
                break;

            case "OpenExternalMenuMessage":
                this.mainMenuHandler();
                break;

            case "BigWinAnimationStateMessage":
                if (message.isPlaying === false) {
                    this.wrapperHandler.dispatch("GameStateEvents.WIN_ANIMATION_STOPPED");
                } else {
                    this.wrapperHandler.dispatch("GameStateEvents.WIN_ANIMATION_STARTED");
                }
                break;

            case "JackpotWinAnimationFinishedMessage":
                this.wrapperHandler.dispatch("GameStateEvents.JACKPOT_WIN_ANIMATION_STOPPED");
                break;

            case "CommandsCompleteModuleMessage":
                this.commandsCompleteHandler();
                break;

            case "ExternalSetBetModuleMessage":
            case "ExternalBetChangedModuleMessage":
                this.betChangedHandler(message.bet);
                break;

            case "SetBetUnitsMessage":
            case "ExternalSetBetUnitsMessage":
                this.betChangedHandler(message.betUnits);
                break;

            case "ExternalResumeRequest":
            case "ExternalResumeRequestMessage":
                this.resumeRequestHandler();
                break;

            case "ExternalGameRequestMessage":
                this.gameRequestHandler(message.payload);
                break;

            case "PlayerWonModuleMessage":
                this.wrapperHandler.setAmountWon(message.amountWon);
                break;

            case "AutoSpinStateChangedMessage":
                this.wrapperHandler.setAutospinsStarted(message.isStarted);
                this.wrapperHandler.dispatch("GameStateEvents.GAME_MODE_CHANGED", "AUTO_SPIN_MODE");
                if(message.isStarted)
                    this.wrapperHandler.dispatch("ExternalEvent.AUTO_PLAY_STARTED");
                else
                    this.wrapperHandler.dispatch("ExternalEvent.AUTO_PLAY_STOPPED");
                break;

            case "MiniGameEnteringModuleMessage":
                this.wrapperHandler.dispatch("ExternalEvent.FEATURE_STARTED");
                break;

            case "MiniGameFinishedModuleMessage":
                this.wrapperHandler.dispatch("GameStateEvents.WIN_ANIMATION_STOPPED");
                this.wrapperHandler.dispatch("ExternalEvent.FEATURE_ENDED");
                this.commandsCompleteHandler();
                break;

            case "FreeSpinsInProgressMessage":
                if (!this.inFreeGame)
                {
                    this.wrapperHandler.dispatch("ExternalEvent.FEATURE_STARTED");
                    this.inFreeGame = true;
                }
                break;

            case "FreeSpinsFinishedMessage":
                if (this.inFreeGame)
                {
                    this.wrapperHandler.dispatch("ExternalEvent.FEATURE_ENDED");
                    this.inFreeGame = false;
                }
                break;

            case "FreeSpinDisplayStateChangedMessage":
                this.wrapperHandler.dispatch(
                    message.freeSpinStateActive ? "ExternalEvent.FEATURE_STARTED" : "ExternalEvent.FEATURE_ENDED");
                break;

            case "CreditChangedModuleMessage":
                this.wrapperHandler.notifyAboutCreditChange(message.credit);
                break;

            case "RespinsCompleteResponseMessage":
                this.wrapperHandler.forceCreditChangeNotification();
                this.commandsCompleteHandler();
                break;

            case "ExternalGameTitleChanged":
                this.wrapperHandler.sendTitleChangedNotification(message.title);
                break;

            case "ExternalShowMessageBoxMessage":
                this.wrapperHandler.showPopup(message);
                break;

            case "HideMessageBoxMessage":
                this.wrapperHandler.hidePopup();
                break;
        }
    }

    public formatNumber(value: number, settings: any): string
    {
        return this.wrapperHandler.formatNumber(value, settings);
    }

    public onLoadingProgress(progress: number): void
    {
        this.wrapperHandler.dispatch("ExternalEvent.GAME_LOADING_PROGRESS", progress);
    }

    public useExternalMessageBox(message: any): boolean
    {
        return this.wrapperHandler.useExternalMessageBox(message);
    }

    protected receiveGameResponse(response: any): void
    {
        this.currentStage = response.GameState_Stage as number;
        this.currentRoundEndState = response.GameState_RoundEnd  as number;

        if(!this.roundStarted && this.currentStage > 0 && this.currentRoundEndState === 0)
            this.roundStarted = true;
    }

    protected spinStoppedHandler(): void {
        this.wrapperHandler.dispatch("GameStateEvents.REELS_STOPPED");
    }

    private spinStartedHandler(): void {
        this.wrapperHandler.dispatch("GameStateEvents.REELS_STARTED");

        if(this.currentStage === 0 && !this.roundStarted)
        {
            this.wrapperHandler.dispatch("GameStateEvents.ROUND_STARTED");
            this.roundStarted = true;
        }
    }

    protected payTableEventHandler(value: boolean): void {
        if(this.paytableOpened === value)
            return;

        const eventType = value ? "GameStateEvents.PAY_TABLE_OPENED" : "GameStateEvents.PAY_TABLE_CLOSED";
        this.wrapperHandler.dispatch(eventType);
        this.paytableOpened = value;
    }

    protected mainMenuHandler(): void {
        this.wrapperHandler.setMainMenuState()
    }

    protected commandsCompleteHandler(): void
    {
        if(this.currentRoundEndState === 1 && this.roundStarted)
        {
            this.wrapperHandler.dispatch("GameStateEvents.ROUND_ENDED");
            this.roundStarted = false;
        }
    }

    private betChangedHandler(betValue: number)
    {
        if(this.currentBetValue === betValue)    return;

        this.wrapperHandler.dispatch("GameStateEvents.GAME_BET_CHANGED");
        this.currentBetValue = betValue;
    }

    private async resumeRequestHandler()
    {
      this.wrapperHandler.sendResumeResponse();
    }

    private async gameRequestHandler(payload: any)
    {
      this.wrapperHandler.sendGameResponse(payload);
    }
}
